// @ts-nocheck
import { IS_JEST } from 'shared/consts'
import { FEATURE_FLAG_COOKIE } from 'shared/consts/featureFlagCookie'
import { TENANT_AT, TENANT_COM, TENANT_IT } from 'shared/consts/tenants'
import { isMarketplace, isSaeOnly } from 'shared/experiments/utils/featureFlags'
import { mapExperiments } from 'shared/experiments/utils/mapExperiments'
import logger from 'shared/services/logger'
import store from 'shared/store'
import { getCookieByName } from 'shared/utils/getCookie'
import { formatPathWithLanguage } from 'shared/utils/url'
import buildClientAPI from 'views/providers/clientAPI'

const MINICART_BADGE_SELECTORS = [
  '[data-clientside-hook~="Menubar__cart-badge"]',
  '[data-clientside-hook~="SmallHeader__cart-badge"]',
]

const MINICART_LINK_SELECTORS = [
  '[data-clientside-hook~="Menubar__cart-link"]',
  '[data-clientside-hook~="SmallHeader__cart-link"]',
]

/**
 * fail-save (for not found element) querying and setting of props
 *
 * @param {string} selector querySelector for the desired element
 * @param {object} props key/value pairs of props to set
 */
const selectAndSet = (selector, props) => {
  const element = document.querySelector(selector)
  if (element) {
    Object.keys(props).forEach(key => {
      element[key] = props[key]
    })
  }
}

const fetchSaeOrMarketplaceCookie = async (language, tenant, expa) => {
  //TODO remove when rolled for all countries
  const tenants = [TENANT_COM, TENANT_AT, TENANT_IT]

  if (!tenants.includes(tenant)) return false

  let featureFlagCookie: unknown = getCookieByName(
    FEATURE_FLAG_COOKIE,
    document.cookie
  )

  if (!featureFlagCookie) {
    const urlSearchParams = new URLSearchParams(window.location.search)
    const params = Object.fromEntries(urlSearchParams.entries())
    const headers: unknown = {}

    if (typeof params.release !== 'undefined') {
      headers['X-Feature-Release'] = params.release
    }

    if (expa) {
      headers['X-Feature-Expa'] = expa
    }

    await fetch(
      `/webclient/experiments/${tenant}/${language}/getUserFeaturesCookie`,
      {
        headers,
      }
    )
    featureFlagCookie = getCookieByName(FEATURE_FLAG_COOKIE, document.cookie)
  }
  let experiments = {}

  try {
    experiments = JSON.parse(featureFlagCookie)
  } catch (error) {
    logger.error(`Feature toggle cookie error: ${error.message}`)
  }

  const experimentsUpdated = mapExperiments({ experiments })

  if (!experimentsUpdated) return false

  return experimentsUpdated
}

export default async () => {
  const {
    pageProperties: { experiments: experimentsFromState, expa },
    publicConfig: { language, tenant },
  } = store.getPublicRuntimeConfig()

  let experiments = experimentsFromState
  const formatPath = formatPathWithLanguage(tenant)(language)

  /*
   * Fetch necessary experimental cookies and set if needed
   */
  const isHardCachedPage =
    window.location.pathname.includes('/lp/') ||
    window.location.pathname.includes('/promotions/')

  if (isHardCachedPage && !IS_JEST) {
    const updatedExperiments = await fetchSaeOrMarketplaceCookie(
      language,
      tenant,
      expa
    )
    if (updatedExperiments) {
      experiments = updatedExperiments
    }
  }

  if (isSaeOnly(experiments, tenant) || isMarketplace(experiments, tenant)) {
    const { cartServiceV3 } = buildClientAPI()
    const miniCart = await cartServiceV3.fetchMiniCart()

    const cartQuantity = miniCart?.data?.entriesInCart || 0

    MINICART_BADGE_SELECTORS.forEach(selector => {
      selectAndSet(selector, { textContent: cartQuantity })
    })

    MINICART_LINK_SELECTORS.forEach(selector => {
      selectAndSet(selector, {
        href: formatPath('/nx/cart'),
      })
    })
  } else {
    MINICART_LINK_SELECTORS.forEach(selector => {
      selectAndSet(selector, {
        href: formatPath('/cart.htm'),
      })
    })
  }
}
